import type { CashoutOffers } from "@/types/ApiResponses/Cashout";

// How often open coupons' offers are re-asked while the page is visible
// (react-query pauses the interval in a background tab).
export const CASHOUT_POLL_INTERVAL_MS = 5000;

/**
 * The offers query's refetch interval. Polling backs off to none when there
 * is nothing to price: no ids, an empty answer (no own coupon), or every
 * answer "disabled" (the kill switch or the dealer rule is off, so nothing
 * will change on its own). A refocus or a new open coupon (a new query key)
 * asks again. Until the first answer arrives, it polls.
 */
export const getCashoutPollInterval = (
  offers: CashoutOffers | undefined,
  requestedCount: number
): number | false => {
  if (requestedCount === 0) return false;
  if (offers === undefined) return CASHOUT_POLL_INTERVAL_MS;

  const entries = Object.values(offers);
  if (entries.length === 0) return false;

  const allDisabled = entries.every(
    (entry) => entry.kind === "unavailable" && entry.reason === "disabled"
  );
  return allDisabled ? false : CASHOUT_POLL_INTERVAL_MS;
};
